import classNames from "classnames";
import { TooltipInfo } from "components/info-tooltip";

export function EvtHeader({ title, children, className, info ,description}) {
  return (
    <div className={classNames("bg-background  py-4", className)}>
      <div className="mx-auto px-4 lg:px-6 flex justify-between items-center">
        <div className="space-y-1">
        <div className="flex gap-2 items-center">
          <h1 className="text-xl md:text-2xl font-bold tracking-tight">
            {title}
          </h1>
          {info && <TooltipInfo info={info} />}
        </div>
        {description && description}
        </div>
        <div className="flex items-center gap-2">{children}</div>
      </div>
    </div>
  );
}

export function EvtSectionHeader({
  title,
  description,
  children,
  className,
  info,
}) {
  return (
    <div className={classNames("bg-background pt-4 md:pt-6", className)}>
      <div className="lg:px-6 px-4 flex flex-col gap-6">
        <div className="flex justify-between md:items-center md:gap-6 gap-4 md:flex-row flex-col">
          <div className="space-y-1">
            <div className="flex gap-2 items-center justify-between md:justify-start">
              <h2 className="text-xl font-semibold">{title}</h2>
              {info && <TooltipInfo info={info} />}
            </div>

            <p className="text-sm text-muted-foreground">{description}</p>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
